import { useMutation } from "react-query";
import { UpdateTechnicalWorkSchedule } from "services/workSchedule";

export default function UseUpdateTechnicalWorkSchedule() {
  return useMutation(
    (data:any) => UpdateTechnicalWorkSchedule(data),
  );
}
